<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  @if (dataIsLoaded) {
    <div
      class="modal-body text-start p-5"
      [innerHTML]="data.text"
      [attr.data-id]="data.linkUrl"
      [attr.data-position]="src + '_modal'"
      attr.data-name="{{ src + '.campaign' | i18n: 'usanadotcom' }}"
      [attr.data-creative]="data.linkText"
      inViewport
      (inViewportAction)="captureView($event)"
    ></div>
  }
</ng-template>

@if (dataIsLoaded && visible) {
  @if (!hasInnerText(data.linkUrl) && hasInnerText(data.linkText)) {
    <button
      [style.background-color]="bannerBackgroundColor"
      [style.color]="bannerTextColor"
      class="btn btn-block"
      (click)="open(content)"
    >
      <small>
        <strong>{{ data.linkText }}</strong>
      </small>
      <span aria-hidden="true" (click)="closeBanner()" class="close">
        <fa-icon [icon]="['fal', 'times']"></fa-icon>
      </span>
    </button>
  }
  @if (hasInnerText(data.linkUrl) && !isPCorAbove && hasInnerText(data.linkText)) {
    <span class="btn-block">
      <a
        [style.background-color]="bannerBackgroundColor"
        [style.color]="bannerTextColor"
        class="btn"
        target="_blank"
        [attr.data-automation]="urlPathId(data.linkUrl)"
        [href]="data.linkUrl"
        [attr.data-id]="data.linkUrl"
        [attr.data-position]="src + '_direct_link'"
        attr.data-name="{{ src + '.campaign' | i18n: 'usanadotcom' }}"
        [attr.data-creative]="data.linkText"
        inViewport
        (inViewportAction)="captureView($event)"
        (click)="captureClick($event)"
      >
        <small>
          <strong>{{ data.linkText }}</strong>
        </small>
      </a>
      <span aria-hidden="true" (click)="closeBanner()" class="close">
        <fa-icon [icon]="['fal', 'times']"></fa-icon>
      </span>
    </span>
  }
  @if (hasInnerText(data.aoUpsellLinkUrl) && isPCorAbove) {
    <span class="btn-block">
      <a
        [style.background-color]="bannerBackgroundColor"
        [style.color]="bannerTextColor"
        class="btn"
        target="_blank"
        [attr.data-automation]="urlPathId(data.aoUpsellLinkUrl)"
        [href]="data.aoUpsellLinkUrl"
        [attr.data-id]="data.linkUrl"
        [attr.data-position]="src + '_direct_link'"
        attr.data-name="{{ src + '.campaign' | i18n: 'usanadotcom' }}"
        [attr.data-creative]="data.aoUpsellText"
        inViewport
        (inViewportAction)="captureView($event)"
        (click)="captureClick($event)"
      >
        <small>
          <strong>{{ data.aoUpsellLinkText }}</strong>
        </small>
      </a>
      <span aria-hidden="true" (click)="closeBanner()" class="close">
        <fa-icon [icon]="['fal', 'times']"></fa-icon>
      </span>
    </span>
  }
}
